import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import lottie from "lottie-web";
import axios from "axios";

import { Header } from "./Comps/Header";
import ScreenTitle from "./Comps/ScreenTitle";
import animationData from "../../assets/JSON animations/Comp 1.json";
import routes from "../../../layout/Routes";
import { env } from "../../environment/environment";

export default function FibeNumberVerified() {
    const navigate = useNavigate();
    const [userId, setUserId] = useState(null);
    const timerId = useRef(null);

    useEffect(() => {
        const storedUserId = localStorage.getItem("userId");
        if (storedUserId && storedUserId !== "null") {
            setUserId(storedUserId);
        }
    }, []);

    const handleNavigationByFormStatus = async (status, loanId) => {

        const routeMap = {
            AGREEMENT_SIGNED: '/patient/bankdetailsforNACH/' + loanId,
            FACE_VERIFIED: "/patient/agreementesigning/" + loanId,
            AADHAAR_VERIFIED: "/patient/fdpersonaldetails/"+localStorage.getItem("userId"),
            PAN_VERIFIED: "/patient/professional/" + localStorage.getItem("userId"),
            INCOME_VERIFIED: "/patient/digireport",
            MANDATE_VERIFIED: "/patient/final",
            FINDOC_APPROVED: '/patient/bureauapproved/' + localStorage.getItem("userId"),
            FINDOC_INCOME_VERIFICATION_REQUIRED: '/patient/digibankstatement/' + localStorage.getItem("userId"),
            JP_CARDLESS_ELIGIBLE: '/patient/cardlessapproved-juspay/'+ localStorage.getItem("userId"),
            FINDOC_BS_APPROVED: '/patient/BSapprovedEMI/' + loanId,
            BANK_ACCOUNT_VERIFIED: '/patient/emiautopaysetup/' + loanId,
            FINDOC_BS_REJECTED: '/patient/RejectedScreen/' + localStorage.getItem("userId"),
            ADDRESS_SAVED: '/patient/digilockerintro/' + loanId,
            EMI_PLAN_SAVED: '/patient/postapprovalAddressdetails/' + localStorage.getItem("userId"),
            PD_OKY_AADHAAR_VERIFIED: '/patient/fdpersonaldetails',
            PD_OKY_PAN_VERIFIED: '/patient/professional/' + localStorage.getItem("userId"),
            PA_OKY_AADHAAR_VERIFIED: '/patient/faceverification/' + localStorage.getItem("userId"),
            PA_DKYC_VERIFIED: '/patient/faceverification/' + localStorage.getItem("userId"),
            BS_REJECTED: '/patient/rejectionbybs/' + localStorage.getItem("userId"),
            FIBE_BS_REQUIRED: '/patient/fibeV2BankStatementRequired/' + loanId,
            FIBE_APPROVED: '/patient/fibev2approved/' + loanId,
            CARDLESS_EMI_PLAN_SAVED: '/patient/cardlessapproved-juspay/'+ localStorage.getItem("userId"),
            FIBE_TENURE_LOCKED:'/patient/junction?loanId='+loanId+'&userId='+localStorage.getItem("userId")

        };
        navigate(routeMap[status] || "/patient/findocKYCintro/"+localStorage.getItem("userId"));
    };

    const checkDigitapDataForArthmate = async () => {
        try {
            const res = await axios.get(`${env.api_Url}checkAMFlowGreenOrAmber?userId=${userId}`);
            if (res.data.message === "success") {
                const status = res.data.data;
                if (status === "GREEN") return navigate(routes.ARTH_CONGRATULATIONS);
                if (status === "AMBER") return navigate(routes.DIGITAP_BANK_STATEMENT);
            }
        } catch (error) {
            console.error("Error fetching AM flow status:", error);
        }
    };

    const handleFibeFlow = async () => {
        try {
            const res = await axios.get(`${env.api_Url}checkFibeFlow?userId=${userId}`);
            const status = res.data.data;
            if (status === "GREEN") return navigate(routes.FIBE_LOAN_APPROVED);
            if (status === "AMBER") return navigate(routes.FIBE_BANK_STATEMENT_REQUIRED);
        } catch (error) {
            console.error("Fibe flow check failed", error);
        }
    };

    const handleMVFlow = async () => {
        try {
            const loanRes = await axios.get(`${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`);
            const loanId = loanRes.data.data.loanId;
            const mvRes = await axios.get(`${env.api_Url}moneyViewActivityStatus?loanId=${loanId}`);
            const leadStatus = mvRes.data.data.leadStatus;
            if (leadStatus === "DOCS_REQUIRED") navigate(routes.MONEY_VIEW_BANKSTATEMENT);
            else if (leadStatus === "NOT_REQUIRED") navigate(routes.MV_CONGRATULATIONS);
        } catch (error) {
            console.error("MV flow error", error);
        }
    };

    const handleFinzyFlow = async () => {
        try {
            const loanRes = await axios.get(`${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`);
            const loanId = loanRes.data.data.loanId;
            const finzyRes = await axios.get(`${env.api_Url}finzy/getFinzyDetailByLoanId?loanId=${loanId}`);
            if (finzyRes.data.message === "success") {
                const offered = finzyRes.data.data.loanAmountOffered;
                const requested = loanRes.data.data.loanAmount;
                navigate(offered === requested ? routes.FINZY_APPROVAL : routes.FINZY_APPROVE_LESS_AMOUNT);
            }
        } catch (error) {
            console.error("Finzy flow error", error);
        }
    };

    const handleIncredFlow = async () => {
        try {
            const res = await axios.get(`${env.api_Url}getIncredStatusForUser?userId=${userId}`);
            const status = res.data.data.status;
            if (status === "GREEN") navigate(routes.APPROVAL_INCRED);
            else if (status === "AMBER") navigate(routes.INCRED_PREAPPROVED);
        } catch (error) {
            console.error("Incred flow error", error);
        }
    };

    const checkFinalNbfcAndNavigate = async () => {
        try {
            const res = await axios.get(`${env.api_Url}getFinalNbfc?userId=${userId}`);
            const nbfc = res.data.data;

            switch (nbfc) {
                case "AM":
                    return checkDigitapDataForArthmate();
                case "CF":
                    return navigate(routes.CONGRATS);
                case "FIBE":
                    return handleFibeFlow();
                case "INCRED":
                    return handleIncredFlow();
                case "MV":
                    return handleMVFlow();
                case "FINZY":
                    return handleFinzyFlow();
                case "WAIT":
                    return navigate(routes.WAIT_FOR_PROCESSING);
                case "LOL":
                case "NOT_FIT":
                case "NOT_MAPPED":
                    return navigate('/patient/RejectedScreen/' + userId)
                        ;
                default:
                    return;
            }
        } catch (error) {
            console.error("Error fetching Final NBFC", error);
        }
    };

    const handleFindocFlow = async () => {
        try {
            const loanRes = await axios.get(`${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`);
            const formStatusRes = await axios.get(`${env.api_Url}userDetails/getUserLoanFormStatus?userId=${userId}`);
            if (formStatusRes.data.message === "success") {
                handleNavigationByFormStatus(formStatusRes.data.data, loanRes.data.data.loanId);
            } else {
                navigate("/patient/findocKYCintro");
            }
        } catch (error) {
            console.error("Error in Findoc flow, navigating to intro");
            navigate("/patient/findocKYCintro");
        }
    };

    useEffect(() => {
        const fetchNbfcAndNavigate = async () => {
            try {
                const loanRes = await axios.get(`${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`);
                if (loanRes.data.message === "success") {
                    const doctorId = localStorage.getItem("doctorId");
                    const nbfcRes = await axios.get(`${env.api_Url}userDetails/getNbfcStatusForDoctor?doctorId=${doctorId}`);
                    const isFindoc = nbfcRes.data.status === 200;

                    if (isFindoc) return handleFindocFlow();
                    // else return checkFinalNbfcAndNavigate();
                } else {
                    return navigate('/patient/FindocKYCintro/'+userId);
                }
            } catch (error) {
                console.error("Loan or NBFC error", error);
                return navigate('/patient/FindocKYCintro/'+userId);
            }
        };

        if (userId) {
            fetchNbfcAndNavigate();
        }
    }, [userId]);

    useEffect(() => {
        lottie.loadAnimation({
            container: document.querySelector("#searchAnimation"),
            animationData,
            renderer: "canvas",
        });

        return () => {
            if (timerId.current) clearTimeout(timerId.current);
        };
    }, []);

    return (
        <main className="screenContainer">
            <Header progressBar="hidden" />
            <div id="searchAnimation" style={{ marginTop: "25%" }}></div>
            <ScreenTitle
                id="screen3Title"
                className="fadeInUpAnimate"
                title="Mobile number verified!"
                styles={{
                    color: "#514C9F",
                    textAlign: "center",
                    margin: "0",
                    opacity: "0",
                }}
            />
        </main>
    );
}
